// extracted by mini-css-extract-plugin
module.exports = {"inputSearch":"FilterAssign_inputSearch__FH-bx"};